import React ,  {useState,useEffect}  from "react";
import {useLocation,useNavigate} from "react-router-dom";

const ComedyBreadCrumb = ({ breadCrumb }) => {
  const { one, two } = breadCrumb || {};
  const  location = useLocation().pathname
  const  isContents = location.includes('contents/') ? true : false
  const  isVideosList = location.includes('videoslist/') ? true : false
  const  isContentPage = location.includes('content/') ? true : false;

  const contentscategories = [
    { text: "Facebook Fun", link: "/comedy/contents/facebookfun-1168.html" },
    { text: "comedy", link: "/comedy/contents/comedy-80.html" },
    { text: "Jokes", link: "/comedy/contents/jokes-23.html" },
    { text: "Brahmanandam Jokes", link: "/comedy/contents/brahmanandamjokes-640.html" },
    { text: "Three-in-One", link: "/comedy/contents/three-in-one-1135.html" },
    { text: "Fun Corner", link: "/comedy/contents/funcorner-1134.html" },
    { text: "My Dear Romeo", link: "/comedy/contents/mydearromeo-1053.html" },
    { text: "Cheapey Rayudu", link: "/comedy/contents/cheapeyrayudu-942.html" },
    { text: "Silly Fellow", link: "/comedy/contents/sillyfellow-941.html" },
    { text: "Hello Wrong Number", link: "/comedy/contents/hellowrongnumber-933.html" },
    { text: "Fun time", link: "/comedy/contents/funtime-654.html" },
    { text: "Audio Serieal", link: "/comedy/contents/audioserieal-24.html" },
    { text: "Taataadhithai Tadiginatom", link: "/comedy/contents/taataadhithaitadiginatom-758.html" },
    { text: "Aahanagar Colony", link: "/comedy/contents/aahanagarcolony-709.html" },
    { text: "Saddam Aunty Inti Katha", link: "/comedy/contents/saddamauntyintikatha-707.html" },
    { text: "Audio Jokes", link: "/comedy/contents/audiojokes-669.html" },
    { text: "Wife and Husband Jokes", link: "/comedy/contents/wifeandhusbandjokes-659.html" },
    { text: "General Jokes", link: "/comedy/contents/generaljokes-657.html" },
    { text: "Sports Jokes", link: "/comedy/contents/sportsjokes-661.html" },
    { text: "Political Jokes", link: "/comedy/contents/politicaljokes-655.html" },
    { text: "Youth and Romantic Jokes", link: "/comedy/contents/youthandromanticjokes-660.html" },
    { text: "Software and IT Jokes", link: "/comedy/contents/softwareanditjokes-658.html" },

    { text: "Shivatandavam", link: "/comedy/contents/shivatandavam-642.html" },
    { text: "Mallikkrazy", link: "/comedy/contents/mallikkrazy-641.html" },
    { text: "Ammo Ammayilu", link: "/comedy/contents/ammoammayilu-623.html" },
    { text: "Antera Bamardee", link: "/comedy/contents/anterabamardee-538.html" },
    { text: "Yeluka Vacche Illu Bhadram", link: "/comedy/contents/yelukavaccheillubhadram-340.html" },
    { text: "Maliks", link: "/comedy/contents/maliks-5.html" },
    { text: "Sampurna Golayanam", link: "/comedy/contents/sampurnagolayanam-319.html" },
    { text: "The Diary of LEKHA GUMMADI", link: "/comedy/contents/thediaryoflekhagummadi-284.html" },
    { text: "Audio Serial", link: "/comedy/contents/audioserial-282.html" },
    { text: "Games", link: "/comedy/contents/games-61.html" },
    { text: "Rampandu Leelalu", link: "/comedy/contents/rampanduleelalu-60.html" },
    { text: "Puzzle", link: "/comedy/contents/puzzle-62.html" },
    { text: "Daily Serials", link: "/comedy/contents/dailyserials-3.html" },
    { text: "Hot Shot", link: "/comedy/contents/hotshot-26.html" },
    { text: "Tingu", link: "/comedy/contents/tingu-27.html" },
    { text: "Comedy Stories", link: "/comedy/contents/tingu-27.html" },
    { text: "Oo Mallikanna", link: "/comedy/contents/oomallikanna-28.html" },
    { text: "Siggu Siggu", link: "/comedy/contents/siggusiggu-25.html" },
    { text: "Gura Vayanam", link: "/comedy/contents/guravayanam-29.html" },
    { text: "Andaru Dongale", link: "/comedy/contents/andarudongale-20.html" },
    { text: "Audio Cartoons", link: "/comedy/contents/audiocartoons-6.html" },
    { text: "Prema Pandem", link: "/comedy/contents/premapandem-21.html" },
    { text: "Articles", link: "/comedy/contents/articles-4.html" }
  ];


const videoslistcategories = [
   { text: "Erri Dippa" , link: "/comedy/videoslist/erridippa-25.html"},
   { text: "Spoofs" ,link: "/comedy/videoslist/spoofs-26.html" },
   { text: "Mallik Comedy" ,link: "/comedy/videoslist/mallikcomedy-6.html" },
   {text: "Shhh Gup Chip" ,link: "/comedy/videoslist/shhhgupchip-5.html" },
   {  text: "Happy Happyga" ,link: "/comedy/videoslist/happyhappyga-4.html" },
   {text: "Telugu Comedy Videos",link: "/comedy/videoslist/telugucomedyvideos-14.html"  },
   { text: "Archives",link: "/comedy/videoslist/archives-31.html"  },
]; 


    const [selectedValue, setSelectedValue] = useState("");
    const navigate = useNavigate();
  
   useEffect(() => {
    if (!one) return;
    let match = {}

    if (isContents) {
    match = contentscategories.find(
        (item) => item.text.toLowerCase() === one.toLowerCase()
      );
    }
    else if (isVideosList) {
       match = videoslistcategories.find(
        (item) => item.text.toLowerCase() === one.toLowerCase()
      );
    }

      if (match) {
       setSelectedValue(match.link);
      }
}, [one]);




   const handleChange = (e) => {
       const url = e.target.value;
        if (!url) return;

         setSelectedValue(url);

         // IMPORTANT: remove domain, navigate only with path
          navigate(url.replace("/comedy", ""));
         };

  return (
    <div className="comedy-breadcrumb">
      <p>
        Home <span>»</span> {one}
        {two && <span> » </span>} {two}
      </p>

      {(isContents || isContentPage) && <select
        className="search-input"
        value={selectedValue}
        onChange={handleChange}

        id="CatSelector"
      >
        <option value="">Select Category</option>

        { contentscategories.map((item, index) => (
          <option key={index} className={`${item.link === selectedValue ? 'selected-content' : ''}`} value={item.link}>
            {item.text}
          </option>
        ))}
      </select>}
    </div>
  );
};

export default ComedyBreadCrumb;